document.addEventListener('DOMContentLoaded', function () {

  // ─── ADD TO CART ─────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const atcBtn = e.target.closest('.add-to-cart-icon');
    if (atcBtn) {
      e.preventDefault();
      const variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      const originalColor = atcBtn.style.color;
      atcBtn.style.color = '#4caf50';
      atcBtn.style.transform = 'scale(1.3)';
      setTimeout(() => { atcBtn.style.transform = 'scale(1)'; }, 200);
      setTimeout(() => { atcBtn.style.color = originalColor; }, 1500);

      let rootUrl = window.Shopify?.routes?.root || '/';
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
        .then(response => response.json())
        .then(data => {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch((error) => {
          atcBtn.style.color = '#e53935';
          setTimeout(() => { atcBtn.style.color = originalColor; }, 1500);
          console.error('Add to cart error:', error);
        });
    }
  });

  // ─── RECENTLY VIEWED LOGIC ───────────────────────────────────────────────────
  const recentSections = document.querySelectorAll('.recently-viewed-section:not(.product-recommendations-section)');

  recentSections.forEach(section => {
    const sectionId     = section.dataset.sectionId;
    const currentHandle = section.dataset.productHandle;
    const limit         = parseInt(section.dataset.limit, 10);

    let rootUrl = section.dataset.rootUrl;
    if (!rootUrl.endsWith('/')) { rootUrl += '/'; }

    const STORAGE_KEY = 'indian_vastra_recent_viewed';

    let recentHandles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

    if (currentHandle && currentHandle !== '') {
      recentHandles = recentHandles.filter(h => h !== currentHandle);
      recentHandles.unshift(currentHandle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentHandles.slice(0, 15)));
    }

    const displayHandles = recentHandles.filter(h => h !== currentHandle).slice(0, limit);

    if (displayHandles.length > 0) {
      const fetches = displayHandles.map(handle =>
        fetch(rootUrl + 'products/' + handle + '?section_id=' + sectionId)
          .then(res => res.text())
          .then(text => {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = text;
            const card = tempDiv.querySelector('.rv-card-template');
            if (card) {
              card.classList.remove('rv-card-template');
              return card;
            }
            return null;
          })
          .catch(() => null)
      );

      Promise.all(fetches).then(cards => {
        const grid = document.getElementById(`RecentGrid-${sectionId}`);
        if (!grid) return;

        let addedCount = 0;
        cards.forEach(card => {
          if (card) {
            grid.appendChild(card);
            addedCount++;
          }
        });

        if (addedCount > 0) {
          const template = grid.querySelector('.rv-card-template');
          if (template) template.remove();

          section.style.display = 'block';

          if (window.ShopifyWishlist) {
            window.ShopifyWishlist.syncButtons();
          }
        }
      });
    }
  });
});